export const SET_ORGANIZATION_ID = 'setOrganizationId'
export const SET_COLLECTION_INDEX = 'setCollectionIndex'
export const INCREASE_COLLECTION_INDEX = 'increaseCollectionIndex'
export const DECREASE_COLLECTION_INDEX = 'decreaseCollectionIndex'
